import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { AppUser } from 'types';

export const userToDoc = (user: AppUser): DocumentData => {
  return {
    uid: user.uid,
    email: user.email,
    emailVerified: user.emailVerified,
    isAnonymous: user.isAnonymous,
    isEditor: user.isEditor,
    createdOn: user.createdOn,
    modifiedOn: user.modifiedOn,
    name: user.name ?? '',
  };
};

export const userConverter: FirestoreDataConverter<AppUser> = {
  toFirestore(user: AppUser): DocumentData {
    return userToDoc(user);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): AppUser {
    const user = docSnap.data(options);

    return {
      uid: user.uid,
      email: user.email,
      emailVerified: user.emailVerified,
      isAnonymous: user.isAnonymous,
      isEditor: user.isEditor,
      createdOn: user.createdOn,
      modifiedOn: user.modifiedOn,
      name: user.name ?? '',
    };
  },
};
